var _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetrieveVoicemaill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-289 381 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-267.2,396.5c-2.8,0-5,2.3-5,5c0,1.1,0.4,2.3,1.1,3.1h-4.1c1.8-2.1,1.4-5.3-0.7-7c-0.9-0.7-2-1.1-3.1-1.1 c-2.8-0.1-5.1,2-5.2,4.8c-0.1,2.8,2,5.1,4.8,5.2h12.3c2.8,0.1,5.1-2,5.2-4.8c0.1-2.8-2-5.1-4.8-5.2H-267.2z M-279,404.7 c-1.8,0-3.2-1.5-3.2-3.2c0-1.6,1.2-3,2.8-3.1h0.3c1.8,0.1,3.1,1.7,2.9,3.4C-276.2,403.3-277.4,404.5-279,404.7z M-267.2,404.7 c-1.8,0-3.2-1.4-3.2-3.2c0-1.8,1.4-3.2,3.2-3.2c1.8,0,3.2,1.4,3.2,3.2c0,0,0,0,0,0l0,0C-264,403.3-265.4,404.7-267.2,404.7 L-267.2,404.7z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "-277.6,391.5 -273,395.6 -273,393.3 -268.4,393.3 -268.4,389.8 -273,389.8 -273,387.5 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetrieveVoicemaill);
export default __webpack_public_path__ + "static/media/retrieve-voicemaill.e85d587c.svg";
export { ForwardRef as ReactComponent };